import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../services/baseQuery';
import { toCamelCase } from '../../grid/utils';
import type {
  ExpenseCategoryReportOptions,
  ExpenseCategoryReportRequest,
  ExpenseCategoryReportResult,
} from '../types';

type ApiEnvelope = {
  Code?: number;
  code?: number;
  data?: unknown;
  Data?: unknown;
  message?: string;
};

const API_URL = '/umbraco/api/ExpenseCategoryReport';

const transformResponse = <T>(response: ApiEnvelope): T => {
  if ((response.Code ?? response.code) !== 1) {
    throw new Error(response.message || 'Failed to load expense category report.');
  }
  return toCamelCase(response.data ?? response.Data ?? {}) as T;
};

export const expenseCategoryReportApi = createApi({
  reducerPath: 'expenseCategoryReportApi',
  baseQuery,
  endpoints: (builder) => ({
    getOptions: builder.query<ExpenseCategoryReportOptions, void>({
      query: () => `${API_URL}/GetOptions`,
      transformResponse: (response: ApiEnvelope) =>
        transformResponse<ExpenseCategoryReportOptions>(response),
      keepUnusedDataFor: 300,
    }),
    generateReport: builder.query<ExpenseCategoryReportResult, ExpenseCategoryReportRequest>({
      query: (body) => ({ url: `${API_URL}/Generate`, method: 'POST', body }),
      transformResponse: (response: ApiEnvelope) =>
        transformResponse<ExpenseCategoryReportResult>(response),
    }),
  }),
});

export const { useGetOptionsQuery, useLazyGenerateReportQuery } = expenseCategoryReportApi;
